import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';
registerLocaleData(localeId, 'id');
import { BrowserModule } from '@angular/platform-browser';
import { GalleryModule, GALLERY_CONFIG } from 'ng-gallery';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { ShortenPipe, StripTagsPipe, TrimPipe } from 'ngx-pipes';
import { HttpInterceptors } from './shared/interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { ProposalStatusComponent } from './admin/component/proposal-status/proposal-status.component';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { EditProposalStatusComponent } from './admin/component/edit-proposal-status/edit-proposal-status.component';
import { MatSelectModule } from '@angular/material/select';
import { ImageModalComponent } from './admin/component/image-modal/image-modal.component';
import { FileModalComponent } from './admin/component/file-modal/file-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SetPrioritasComponent } from './admin/component/set-prioritas/set-prioritas.component';
import { FormPasswordComponent } from './admin/component/form-password/form-password.component';
import { FilterModalComponent } from './admin/component/filter-modal/filter-modal.component';
import { FilterAllprogramComponent } from './admin/component/filter-allprogram/filter-allprogram.component';
import { FilterReportComponent } from './admin/component/filter-report/filter-report.component';

import { environment } from 'src/environments/environment';

export function tokenGetter(): string {
  return localStorage.getItem('tsp-token');
}
export const allowedDomains = ['profileimage.studio', 'localhost', 'localhost:4200'];

@NgModule({
  declarations: [
    AppComponent,
    ProposalStatusComponent,
    EditProposalStatusComponent,
    ImageModalComponent,
    FileModalComponent,
    SetPrioritasComponent,
    FormPasswordComponent,
    FilterModalComponent,
    FilterAllprogramComponent,
    FilterReportComponent
  ],
  imports: [
    JwtModule.forRoot({
      config: {
        tokenGetter,
        allowedDomains
      },
    }),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTableModule,
    MatMenuModule,
    MatSelectModule,
    GalleryModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: LOCALE_ID, useValue: 'id-ID'
    },
    HttpInterceptors,
    ShortenPipe,
    StripTagsPipe,
    TrimPipe,
    {
      provide: GALLERY_CONFIG,
      useValue: {
        dots: true,
        imageSize: 'cover'
      }
    }
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    ProposalStatusComponent,
    EditProposalStatusComponent,
    ImageModalComponent,
    FileModalComponent,
    SetPrioritasComponent,
    FormPasswordComponent,
    FilterModalComponent,
    FilterAllprogramComponent,
    FilterReportComponent
  ]
})
export class AppModule { }
